import React from 'react'
import irelandApi from '../irelandApi'
import {toast} from "react-toastify";
import ToastMessage from "../components/common/toast-message";
import {history} from "../store";
import {actions} from "react-redux-form";
import FileDownload from "react-file-download";

export const getOrderLimits = () => (dispatch) => {
  dispatch({type: "GET_ORDER_LIMIT_LIST_PENDING"});
  return irelandApi.get(`/api/admin/order_limits`)
    .then((response) => {
      dispatch({type: "GET_ORDER_LIMIT_LIST_FULFILLED", payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_ORDER_LIMIT_LIST_REJECTED', payLoad: error.data})
    })
};

export const getOrderLimit = (id) => (dispatch) => {
  dispatch({type: "GET_ORDER_LIMIT_PENDING"});
  return irelandApi.get(`/api/admin/order_limits/${id}`)
    .then((response) => {
      const attributes = response.data.data.attributes;
      const data = {
        categories: attributes['categories'],
        active: ''+attributes.active,
        start_date: attributes['start-date'],
        end_date: attributes['end-date'],
      };
      dispatch(actions.load('deep.admin_order_limit', data));
      if (data.categories.length === 0) {
        dispatch(actions.setErrors(`deep.admin_order_limit.categories`, 'This field is required'));
      }
      dispatch({type: "GET_ORDER_LIMIT_FULFILLED", payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_ORDER_LIMIT_REJECTED', payLoad: error.data})
    })
};

const prepareOrderLimitFormData = (payLoad) => {
  let formData = new FormData();
  Object.keys(payLoad).forEach(key => {
    if (key === 'categories') {
      payLoad[key].forEach(category => {
        formData.append(`order_limit[categories][]`, category.value)
      });
    } else {
      formData.append(`order_limit[${key}]`, payLoad[key])
    }
  });
  return formData;
};

export const updateOrderLimit = (id, payLoad) => {
  let formData = prepareOrderLimitFormData(payLoad);
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };
  return irelandApi.patch(`/api/admin/order_limits/${id}`, formData, config)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Order Limit has been saved successfully"/>);
      history.push('/admin/order_limits');
    })
    .catch((error) => {
      return Promise.reject(error);
    })
};

export const downloadOutletOrderLimits = (type) => (dispatch) => {
  const filename = type + "_max_order_limit.csv";
  return irelandApi.get(`/api/admin/${filename}`)
    .then((response) => {
      FileDownload(response.data, filename);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message={`Outlet order limits can not be downloaded: ${error.response.data.errors[0]}`}/>);
    })
};


// WEBPACK FOOTER //
// ./src/actions/order-limits.js